<template>
  <div>
    <div class="pb-6">
      <div class="row align-items-center py-4 w-100">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">
            {{ $route.meta.title }}
          </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <!-- Menu -->
          </nav>
        </div>
        <div class="col-lg-6 col-5 text-right">
        </div>
      </div>
    </div>

    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col-md-12">
          <div class="card-wrapper">
            <div class="card">
              <div class="card-header">
                <h4>Information</h4>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12 mt-4">
                    <div>
                      <label class="form-control-label">Image</label>
                    </div>
                    <div>
                      <img
                        id="artwork-category-image"
                        class="img-fluid"
                        style="object-fit: cover"
                        :src="
                          artworkCategory.cover &&
                          artworkCategory?.cover[0]?.url
                            ? artworkCategory?.cover[0]?.url
                            : '/img/placeholders/block.png'
                        "
                        alt=""
                        loading="lazy"
                      />
                    </div>
                  </div>
                  <div class="col-md-12 mt-4">
                    <label class="form-control-label">Name</label>
                    <input
                      v-model="artworkCategory.name_en"
                      class="form-control"
                      id="name_en"
                      type="text"
                      name="name_en"
                      readonly
                    />
                  </div>
                  <div class="col-md-12 mt-4">
                    <label class="form-control-label">Slug</label>
                    <input
                      v-model="artworkCategory.slug"
                      class="form-control"
                      id="slug"
                      type="text"
                      name="slug"
                      readonly
                    />
                  </div>
                  <!-- <div class="col-md-12 mt-4">
                      <label class="form-control-label">Name Ar</label>
                      <input
                        v-model="artworkCategory.name_ar"
                        class="form-control"
                        id="name_ar"
                        type="text"
                        name="name_ar"
                      />
                    </div> -->
                  <div class="col-md-12 mt-4">
                    <label class="form-control-label">Parent</label>
                    <input
                      v-if="artworkCategory?.parent?.name_en"
                      v-model="artworkCategory.parent.name_en"
                      class="form-control"
                      id="name_en"
                      type="text"
                      name="name_en"
                      readonly
                    />
                    <input
                      v-else
                      class="form-control"
                      id="name_en"
                      type="text"
                      name="name_en"
                      readonly
                      value="No Parent"
                    />
                  </div>
                </div>
              </div>
              <div class="card-footer d-flex justify-content-between"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 d-flex justify-content-between">
          <Button @click.prevent="
              router.push({
                name: 'artwork-categories.index',
              })
            " label="Cancel" class="p-button-secondary" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useAbility } from "@casl/vue";

import useArtworkCategories from "@/composables/ArtworkCategories";



export default {
  components: {
  },
  setup() {
    const { artworkCategory, getArtworkCategory } = useArtworkCategories();

    const router = useRouter();
    const route = useRoute();
    const { can } = useAbility();
    onMounted(() => {
      getArtworkCategory(route.params.id);
    });

    return {
      router,
      artworkCategory,
      can,
    };
  },
  methods: {},
  mounted() {},
};
</script>
